import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class StockStoreWorkOrderAllocationService extends Service {
	constructor(injector: Injector) {
		super("StockStoreWorkOrderAllocation", injector);
	}

	// API
	getGrid() { // placeholder, may not be needed
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetGrid`);
	}
	
	unquarantine(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Unquarantine/${id}`, {});
	}
}